import { createI18n } from "vue-i18n";

const messages: any = {};
const company = process.env.VUE_APP_COMPANY;
const languageSet = process.env.VUE_APP_LANGUAGE_SET.split(',');

// 定義における1件目の国コードをデフォルトとする
const priorityLang = languageSet[0];

for (const lang of languageSet) {
    messages[lang] = loadDefine(company, lang);
}

export const i18n = createI18n<[any], any>({
    locale: priorityLang,
    fallbackLocale: priorityLang,
    silentFallbackWarn: true,
    messages: messages,
});

/**
 * 言語設定ファイルの読み込み \
 * デフォルトを読み込んでから、個社ごとのファイル内容で上書きする。 \
 * 個社ごとのファイルが無ければ、デフォルトを適用する。
 * @param companyId 会社ID
 * @param languageCode 言語コード
 * @returns 
 */
function loadDefine(companyId: string, languageCode: string) {
    // デフォルトの言語設定は必ず存在することが前提
    const defaultSetting = loadSettingFile("default", languageCode);
    try {
        const customSetting = loadSettingFile(companyId, languageCode);
        return deepMerge(defaultSetting, customSetting);
    } catch (e) {
        return defaultSetting;
    }
}

/**
 * 言語設定ファイルの読み込み
 * @param companyId 会社ID
 * @param languageCode 国コード
 * @returns 
 */
function loadSettingFile(companyId: string, languageCode: string) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require(`@/plugins/setting/label/${companyId}/${languageCode}.json`);
}

/**
 * オブジェクトを再帰的にマージする \
 * assignやスプレッド構文の場合、ネストしているオブジェクトのマージは意図しない上書きが発生する。
 * @param target
 * @param source 
 * @returns 
 */
function deepMerge(target: any, source: any) {

    if (!isNonNullObject(target)) return source

    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key) &&
        isNonNullObject(target[key]) &&
        isNonNullObject(source[key])) {
            deepMerge(target[key], source[key]);
        } else {
            target[key] = source[key]
        }
    }
    return target;
}

function isNonNullObject(e: any) {
    return typeof e === `object` && e !== null;
}